export abstract class SpreadsheetColumnMap {
  protected static fields = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

  static getColumns(): Array<string> {
    return this.fields;
  }

  static getColumn(index: number): string {
    return this.fields[index];
  }
}
